<!-- "Where should these files go?" -->
<p-dialog
  [(visible)]="visible"
  [modal]="true"
  appendTo="body"
  [position]="dialogPosition"
  [draggable]="false"
  [resizable]="false"
  [showHeader]="false"
  [dismissableMask]="true"
  [style]="{ width: 'min(520px, 94vw)' }"
  styleClass="sfs-dialog"
  maskStyleClass="sfs-mask"
  (onHide)="onHide()"
>
  <div class="sfs-body" *ngIf="pending">
    <!-- Header strip (Business Partner pattern) -->
    <div class="sfs-header">
      <div class="sfs-logo-badge"><i class="pi pi-inbox"></i></div>
      <div class="sfs-head-text">
        <h3 class="sfs-title">{{ 'sfs.title' | t }}</h3>
        <p class="sfs-subtitle">{{ pending.files.length }} {{ 'sfs.filesReady' | t }}</p>
      </div>
      <button pButton type="button" icon="pi pi-times" class="p-button-text p-button-rounded p-button-sm"
              (click)="cancel()" [attr.aria-label]="'sfs.cancel' | t"></button>
    </div>

    <!-- Files -->
    <div class="sfs-files premium-surface">
      <div class="sfs-file" *ngFor="let f of pending.files; let i = index" [style.animation-delay.ms]="i * 40">
        <span class="sfs-file-icon"><i class="pi" [ngClass]="icon(f)"></i></span>
        <span class="sfs-file-name" [title]="f.name">{{ f.name }}</span>
        <span class="sfs-file-size">{{ size(f.size) }}</span>
        <button type="button" class="sfs-file-x" (click)="remove(i)" [attr.aria-label]="'common.remove' | t">
          <i class="pi pi-times"></i>
        </button>
      </div>
    </div>

    <!-- Step 1: places -->
    <ng-container *ngIf="!pickingDocType && !pickingRecord">
      <div class="sfs-section"><i class="pi pi-map-marker"></i> {{ 'sfs.pickPlace' | t }}</div>

      <div class="sfs-tiles" *ngIf="allowedTiles.length; else noAccess">
        <button type="button" class="sfs-tile" *ngFor="let t of allowedTiles; let i = index"
                [style.animation-delay.ms]="i * 60"
                [class.sfs-tile--off]="!!disabledReason(t)"
                [disabled]="!!disabledReason(t)"
                (click)="pick(t)">
          <span class="sfs-tile-icon"><i class="pi" [ngClass]="t.icon"></i></span>
          <span class="sfs-tile-text">
            <span class="sfs-tile-title">{{ t.titleKey | t }}</span>
            <span class="sfs-tile-hint">{{ disabledReason(t) || (t.hintKey | t) }}</span>
          </span>
          <i class="pi pi-chevron-right sfs-tile-go"></i>
        </button>
      </div>

      <ng-template #noAccess>
        <div class="sfs-empty">
          <div class="sfs-empty-rings"><span></span><span></span><i class="pi pi-lock"></i></div>
          <p>{{ 'sfs.noAccess' | t }}</p>
        </div>
      </ng-template>
    </ng-container>

    <!-- Step 2 (Consignment only): which document type -->
    <ng-container *ngIf="pickingDocType">
      <div class="sfs-section"><i class="pi pi-file"></i> {{ 'sfs.pickDocType' | t }}</div>
      <div class="sfs-chips">
        <button type="button" class="sfs-chip" *ngFor="let d of docTypes" (click)="pickDocType(d.value)">
          <i class="pi" [ngClass]="d.icon"></i>{{ d.labelKey | t }}
        </button>
      </div>
      <button pButton type="button" class="p-button-text p-button-sm sfs-back" icon="pi pi-arrow-left"
              [label]="'sfs.back' | t" (click)="back()"></button>
    </ng-container>

    <!-- Step 3 (Consignment / Stock Unit documents / AI Import): pick the record here -->
    <div class="sfs-step" *ngIf="pickingRecord">
      <div class="sfs-section"><i class="pi pi-search"></i> {{ recordTitleKey | t }}</div>
      <span class="sfs-search">
        <i class="pi pi-search sfs-search-icon"></i>
        <input pInputText type="search" class="w-full sfs-search-input" autocomplete="off" enterkeyhint="search"
               [ngModel]="term" (ngModelChange)="onTerm($event)"
               [placeholder]="'sfs.searchPlaceholder' | t" />
      </span>

      <div class="sfs-results" *ngIf="results.length" role="listbox">
        <button type="button" class="sfs-result" *ngFor="let r of results; let i = index" role="option"
                [style.animation-delay.ms]="i * 50" (click)="pickRecord(r)">
          <span class="sfs-result-icon"><i class="pi" [ngClass]="pickingRecord.icon"></i></span>
          <span class="sfs-result-text">
            <span class="sfs-result-title">{{ r.title }}</span>
            <span class="sfs-result-sub" *ngIf="r.subtitle">{{ r.subtitle }}</span>
          </span>
          <i class="pi pi-arrow-right sfs-tile-go"></i>
        </button>
      </div>

      <!-- Searching: shimmer rows instead of a spinner -->
      <div class="sfs-skels" *ngIf="!results.length && searching" aria-live="polite" [attr.aria-label]="'sfs.searching' | t">
        <div class="sfs-skel" *ngFor="let s of [0, 1, 2]" [style.animation-delay.ms]="s * 120"></div>
      </div>

      <!-- Nothing to show yet / nothing found / error: the same rings graphic as the other empty states -->
      <div class="sfs-empty sfs-empty--sm" *ngIf="!results.length && !searching">
        <div class="sfs-empty-rings"><span></span><span></span>
          <i class="pi" [ngClass]="searchFailed ? 'pi-exclamation-triangle' : (term.trim().length < 2 ? 'pi-search' : 'pi-inbox')"></i>
        </div>
        <p *ngIf="searchFailed">{{ 'sfs.searchFailed' | t }}</p>
        <p *ngIf="!searchFailed && term.trim().length < 2">{{ 'sfs.searchHint' | t }}</p>
        <p *ngIf="!searchFailed && term.trim().length >= 2">{{ 'sfs.searchNone' | t }}</p>
      </div>

      <button pButton type="button" class="p-button-text p-button-sm sfs-back" icon="pi pi-arrow-left"
              [label]="'sfs.back' | t" (click)="back()"></button>
    </div>

    <p class="sfs-note"><i class="pi pi-info-circle"></i> {{ 'sfs.note' | t }}</p>
  </div>
</p-dialog>

<!-- "Files are waiting" pill: shown on every screen after a place was picked, until the files are attached -->
<div class="sfs-pill" *ngIf="pending?.target && !visible">
  <i class="pi pi-inbox"></i>
  <span class="sfs-pill-text">{{ pending!.files.length }} {{ 'sfs.filesReady' | t }} — {{ waitingHint }}</span>
  <button type="button" class="sfs-pill-x" (click)="cancel()" [attr.aria-label]="'sfs.discard' | t">
    <i class="pi pi-times"></i>
  </button>
</div>
